import React from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import PageContent from "../PageContent";
import { go } from "../../logic/actions/navigation";
import {
  DOCUMENT_CAPTURE_PORTRAIT,
  // DOCUMENT_CAPTURE_LOCK,
  // DOCUMENT_CAPTURE_LANDSCAPE,
} from "../../logic/enums/pages";
import { isMobile } from "../../logic/deviceType";
import documentCaptureVideo from "../../assets/videos/02-doc.mp4";
import documentCapturePoster from "../../assets/videos/02-doc.jpg";

PageInstructionVideoDocument.propTypes = {
  go: func,
};

export function PageInstructionVideoDocument(props) {
  const videoStyle = isMobile(navigator.userAgent)
    ? { width: "75%", height: "75%" }
    : { width: "50%", height: "50%" };

  return (
    <PageContent>
      <h1 style={{ margin: "5px" }}>Instruction Video</h1>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <video controls loop autoPlay playsInline style={videoStyle} poster={documentCapturePoster}>
          <source src={documentCaptureVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <button
        className="btn green"
        onClick={() => props.go(DOCUMENT_CAPTURE_PORTRAIT)}
      >
        Start
      </button>
    </PageContent>
  );
}

export default connect(
  (state) => {
    const { lockUI } = state.configuration.extraConfig.featureFlags;
    return {
      lockUI,
    };
  },
  { go }
)(PageInstructionVideoDocument);
